import { Injectable, OnDestroy } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

export enum RestServiceStatus {
  Success = 'success',
  Loading = 'loading',
  NetworkError = 'network-error',
  Error = 'error',
}

@Injectable({
  providedIn: 'root',
})
export abstract class AbstractRestService implements OnDestroy {
  protected status$: BehaviorSubject<RestServiceStatus> =
    new BehaviorSubject<RestServiceStatus>(RestServiceStatus.Success)
  protected errorMessage$: BehaviorSubject<string> =
    new BehaviorSubject<string>(undefined)

  constructor() {
    this.status.subscribe((status) => {
      switch (status) {
        case RestServiceStatus.Success:
          this.errorMessage.next(undefined)
          break
        case RestServiceStatus.Loading:
          this.errorMessage.next(undefined)
          break
        case RestServiceStatus.NetworkError:
          this.errorMessage.next('error.networkLoading')
          break
        case RestServiceStatus.Error:
          this.errorMessage.next('error.loading')
          break
      }
    })
  }

  ngOnDestroy() {
    this.status$.complete()
    this.errorMessage$.complete()
  }

  // Getter for status
  public get status(): BehaviorSubject<RestServiceStatus> {
    return this.status$
  }

  // Getter for error message
  public get errorMessage(): BehaviorSubject<string> {
    return this.errorMessage$
  }

  public isNetworkError(error: any): boolean {
    return error.status === 0 && error.error instanceof ProgressEvent
  }
}
